import ScrollLinksHandler from "../ScrollLink/ScrollLink";

export default class Tooltip {
	static init() {
		if (document.body.classList.contains('neos-backend')) {
			return;
		}
		Array.prototype.forEach.call(document.querySelectorAll('.tooltip'), el => {
			new Tooltip(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.mobileCloneTarget = this.element.dataset.mobileCloneTarget ? this.element.closest(this.element.dataset.mobileCloneTarget) : false;
		this.mobileScrollTarget = this.element.dataset.mobileScrollTarget;
		this.isVisible = false;
		this.isExternal = false;
		this.activeClass = 'tooltip--visible';
		let target = element.querySelector('.tooltip__target');

		target.addEventListener('click', (e) => {
			this.toggle(e);
		});

		document.addEventListener('click', (event) => {
			if (!this.isVisible) {
				return;
			}
			let isClickInside = this.element.contains(event.target);

			if (!isClickInside) {
				this.hide();
			}
		});
	}

	show(e) {
		this.clear();

		if (this.mobileCloneTarget && window.innerWidth < 992) {
			let clone = this.element.cloneNode(true);
			clone.classList.add('tooltip--external', 'tooltip--visible');
			clone.style = '';
			this.mobileCloneTarget.prepend(clone);

			// eventListener for close button
			let externalTooltipTarget = clone.querySelector('.tooltip__target');
			externalTooltipTarget.addEventListener('click', () => {
				clone.remove();
			});
		} else if (this.mobileScrollTarget && window.innerWidth < 992) {
			e.preventDefault();
			ScrollLinksHandler.scrollToLinkHash({hash: this.mobileScrollTarget});
			return;
		} else {
			this.element.classList.add(this.activeClass);
		}

		this.isVisible = true;
	}

	hide() {
		this.element.classList.remove(this.activeClass);
		this.isVisible = false;
	}

	toggle(e) {
		this[!this.isVisible ? 'show' : 'hide'](e);
	}

	clear() {
		let others = this.element.parentElement.querySelectorAll('.' + this.activeClass);
		if (!others) return;

		Array.prototype.forEach.call(others, el => {
			el.classList.remove(this.activeClass);
		});
	}
}
